<nav class="navbar navbar-vertical navbar-expand-md navbar-dark" id="sidenav-main" *ngIf="showSidebar">
  <div class="container-fluid">
    <button id="sideNav" aria-label="sideNav" class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed"
      aria-controls="sidenav-collapse-main">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="d-md-none d-lg-none">
      <a class="navbar-brand pt-0">
        <img alt="Parkit" [src]="parkitLogo" class="navbar-brand-img" />
      </a>
    </div>
    <div class="sidebar-brand d-none d-md-flex">
      <a class="navbar-brand" [routerLink]="[]" (click)="routerName(texts.home)" aria-label="Parkit">
        <img alt="Parkit" [src]="parkitLogo" class="navbar-brand-img" />
      </a>
    </div>
    <ul class="nav align-items-center d-md-none">
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link nav-link-icon" role="button" ngbDropdownToggle>
          <em class="ni ni-bell-55"></em>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <a class="dropdown-item" href="javascript:void(0)">{{ texts.notificationAction }}</a>
          <a class="dropdown-item" href="javascript:void(0)">{{ texts.notificationAnotherAction }}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)">{{ texts.notificationSomethingElse }}</a>
        </div>
      </li>
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Perfil" src="assets/img/svg/img-profile.svg" />
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <p class="ml-3 mb-0 text-secondary">{{ nameProfile }}</p>
          <a class="dropdown-item" (click)="profile()" class="dropdown-item">
            <em class="fa fa-user-plus mr-2" style="color: {{ style }}"></em>
            <span>{{ texts.editProfile }}</span>
          </a>
          <a class="dropdown-item" (click)="password()" class="dropdown-item">
            <em class="fa fa-user-secret mr-2" style="color: {{ style }}"></em>
            <span>{{ texts.changePassword }}</span>
          </a>
          <a [routerLink]="[]" (click)="closeLogout()" class="dropdown-item">
            <em class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-danger"></em>
            <span>{{ texts.closeSession }}</span>
          </a>
        </div>
      </li>
    </ul>
    <div class="collapse navbar-collapse" [ngbCollapse]="isCollapsed" id="sidenav-collapse-main">
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a routerLinkActive="active">
              <img [src]="parkitLogo" alt="Parkit" class="navbar-brand-img" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button id="idLogo" aria-label="logo" type="button" class="navbar-toggler"
              (click)="isCollapsed = !isCollapsed">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
      <p class="sidebar-heading">GENERAL</p>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="[]" (click)="routerName(texts.home)">
            <em class="fas fa-th-large"></em>
            {{ texts.home }}
          </a>
        </li>
        <ng-container *ngIf="idUser === 3">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="[]" data-toggle="collapse" data-target="#collapseSchoolServices">
              <em class="fa fa-qrcode"></em>
              {{ texts.qrSection }}
            </a>
            <div id="collapseSchoolServices" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/scan-qr']" (click)="routerName(texts.qrScanner)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.qrScanner }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 1">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="[]" data-toggle="collapse" data-target="#collapseSchoolServices">
              <em class="far fa-calendar-alt"></em>
              {{ texts.eventsSection }}
            </a>
            <div id="collapseSchoolServices" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/event']" (click)="routerName(texts.eventsQuery)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.eventsQuery }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 2">
          <li class="nav-item">
            <a class="nav-link" role="button" tabindex="0" (click)="toggleSalesMenu()"
              (keydown.enter)="toggleSalesMenu()" (keydown.space)="$event.preventDefault(); toggleSalesMenu()"
              [attr.aria-expanded]="isSalesMenuExpanded" aria-controls="collapseSalesUser">
              <em class="fas fa-ticket-alt"></em>
              {{ texts.buyTicketsSection }}
            </a>
            <div id="collapseSalesUser" class="collapse" [class.show]="isSalesMenuExpanded">
              <div class="bg-light py-2 collapse-inner rounded">
                <a *ngIf="idUser === 2" class="collapse-item" [routerLink]="['/locality']"
                  [class.active]="isSelectEnclosureActive"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  (click)="routerName(texts.selectEnclosure)">
                  <em class="fas fa-map-marker-alt mr-2 text-danger"></em>
                  {{ texts.selectEnclosure }}
                </a>
                <a class="collapse-item" [routerLink]="['/buying-tickets']"
                  [class.active]="isMyTicketsActive"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  (click)="routerName(texts.myTickets)">
                  <em class="fas fa-ticket-alt mr-2 text-danger"></em>
                  {{ texts.myTickets }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 1">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapseSales">
              <em class="fas fa-dollar-sign"></em>
              {{ texts.salesSection }}
            </a>
            <div id="collapseSales" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/general-report']"
                  (click)="routerName(texts.eventReports)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.eventReports }}
                </a>
                <a class="collapse-item" [routerLink]="['/reports']" (click)="routerName(texts.userReports)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.userReports }}
                </a>
                <a class="collapse-item" [routerLink]="['/reports-zone-vip']" (click)="routerName(texts.vipZoneReports)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.vipZoneReports }}
                </a>
                <a *ngIf="idAdmin === 1 || idAdmin === 5" class="collapse-item"
                  [routerLink]="['/prepaid-history-reports']" (click)="routerName(texts.prepaidUserReports)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.prepaidUserReports }}
                </a>
                <a *ngIf="idAdmin === 1 || idAdmin === 5" class="collapse-item" [routerLink]="['/reports-account']"
                  (click)="routerName(texts.careAccountReport)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.careAccountReport }}
                </a>
                <a *ngIf="idAdmin === 1" class="collapse-item" [routerLink]="['/reports-infinity']"
                  (click)="routerName(texts.vipStatusReport)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.vipStatusReport }}
                </a>
                <a *ngIf="idAdmin === 1" class="collapse-item" [routerLink]="['/report-by-month']"
                  (click)="routerName(texts.reportByMonth)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.reportByMonth }}
                </a>
                <a *ngIf="idAdmin === 1 || idAdmin === 5" class="collapse-item"
                  [routerLink]="['/report-by-closing-month']" (click)="routerName(texts.reportClosingMonth)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.reportClosingMonth }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 1 && intIDUsuario === 1">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapseAdmin">
              <em class="fas fa-toolbox"></em>
              {{ texts.adminSection }}
            </a>
            <div id="collapseAdmin" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/users']" (click)="routerName(texts.users)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.users }}
                </a>
                <a class="collapse-item" [routerLink]="['/parkingArea']" (click)="routerName(texts.zones)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.zones }}
                </a>
                <ng-container *ngIf="nameProfile === 'Administrador'">
                  <a class="collapse-item" [routerLink]="['/enclosures']" (click)="routerName(texts.enclosures)">
                    <em class="far fa-circle mr-2 text-danger"></em>
                    {{ texts.enclosures }}
                  </a>
                  <a class="collapse-item" [routerLink]="['/create-locality']" (click)="routerName(texts.localities)">
                    <em class="far fa-circle mr-2 text-danger"></em>
                    {{ texts.localities }}
                  </a>
                </ng-container>
                <a class="collapse-item" [routerLink]="['/parking-zone']"
                  (click)="routerName(texts.parkingZone)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.parkingZone }}
                </a>
                <ng-container *ngIf="nameProfile === 'Administrador'">
                  <a class="collapse-item" [routerLink]="['/eventType']" (click)="routerName(texts.eventTypes)">
                    <em class="far fa-circle mr-2 text-danger"></em>
                    {{ texts.eventTypes }}
                  </a>
                </ng-container>
                <ng-container *ngIf="nameProfile === 'Administrador'">
                  <a class="collapse-item" [routerLink]="['/discount-code']"
                    (click)="routerName(texts.discountCode)">
                    <em class="far fa-circle mr-2 text-danger"></em>
                    {{ texts.discountCode }}
                  </a>
                </ng-container>
                <ng-container *ngIf="nameProfile === 'Administrador'">
                  <a class="collapse-item" [routerLink]="['/disclaimers']" (click)="routerName(texts.disclaimers)">
                    <em class="far fa-circle mr-2 text-danger"></em>
                    {{ texts.disclaimers }}
                  </a>
                </ng-container>
                <a class="collapse-item" [routerLink]="['/generate-qr']" (click)="routerName(texts.qrGeneration)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.qrGeneration }}
                </a>
                <a class="collapse-item" [routerLink]="['/qrabonados']" (click)="routerName(texts.qrSubscribers)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.qrSubscribers }}
                </a>
                <a class="collapse-item" [routerLink]="['/list-parking-pen']"
                  (click)="routerName(texts.parkingPensConfig)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.parkingPensConfig }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="(idUser === 1 && isPrepaid) || nameProfile === 'Administrador'">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapsePrepaid">
              <em class="fas fa-credit-card"></em>
              {{ texts.prepaidSection }}
            </a>
            <div id="collapsePrepaid" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/type-prepaid']" (click)="routerName(texts.prepaidTypes)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.prepaidTypes }}
                </a>
                <a class="collapse-item" [routerLink]="['/prepaid-create']" (click)="routerName(texts.createNewProfile)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.createNewProfile }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="(idUser === 1 && isPrepaid) || nameProfile === 'Administrador'">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapseAdminPrepaid">
              <em class="fas fa-credit-card"></em>
              {{ texts.prepaidUsersAdminSection }}
            </a>
            <div id="collapseAdminPrepaid" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/generateQrToUser']" (click)="routerName(texts.registerQrs)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.registerQrs }}
                </a>
                <a class="collapse-item" [routerLink]="['/change-qr-type']" (click)="routerName(texts.changeQrType)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.changeQrType }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="(idUser === 1 && isPrepaid) || nameProfile === 'Administrador'">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapsePrepago">
              <em class="fas fa-users"></em>
              {{ texts.subscribersSection }}
            </a>
            <div id="collapsePrepago" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/subscribers']" (click)="routerName(texts.subscriberList)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.subscriberList }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 2">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapseAdmin">
              <em class="fas fa-wallet"></em>
              {{ texts.walletSection }}
            </a>
            <div id="collapseAdmin" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/user-tickets']"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  (click)="routerName(texts.wallet)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.wallet }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 2">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/vehicles']" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" (click)="routerName(texts.vehicles)">
              <em class="fas fa-car"></em>
              {{ texts.vehicles }}
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 2 && isPrepaid">
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" data-target="#collapsePrepago">
              <em class="fas fa-credit-card"></em>
              {{ texts.prepaidSection }}
            </a>
            <div id="collapsePrepago" class="collapse">
              <div class="bg-light py-2 collapse-inner rounded">
                <a class="collapse-item" [routerLink]="['/user-prepaid']"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  (click)="routerName(texts.consultReloadQr)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.consultReloadQr }}
                </a>
                <a class="collapse-item" [routerLink]="['/user-prepaid-history']"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  (click)="routerName(texts.movementHistory)">
                  <em class="far fa-circle mr-2 text-danger"></em>
                  {{ texts.movementHistory }}
                </a>
              </div>
            </div>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 1 && intIDUsuario === 1">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/socios-parkit']" (click)="routerName(texts.partners)">
              <em class="fas fa-handshake"></em>
              {{ texts.partners }}
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="idUser === 1 || idUser === 2">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/scan-parking/recinto']" (click)="routerName(texts.scanEnclosure)">
              <em class="fas fa-qrcode"></em>
              {{ texts.scanEnclosure }}
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="sidebar-lang-wrapper mb-2" *ngIf="idUser !== 1">
      <button class="sidebar-lang-btn" type="button" (click)="showLangDialog = !showLangDialog">
        <span class="sidebar-lang-flag">{{ currentLang === 'es' ? '🇲🇽' : '🇺🇸' }}</span>
        <span class="sidebar-lang-label">{{ texts.languageTitle }}</span>
        <i class="fa sidebar-lang-icon" [ngClass]="showLangDialog ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>
      <div class="sidebar-lang-dropdown" *ngIf="showLangDialog">
        <button class="sidebar-lang-option" [class.sidebar-lang-option--selected]="currentLang === 'es'" (click)="selectLang('es')">
          <span>🇲🇽</span> {{ texts.langSpanish }}
          <i class="fa fa-check ml-auto" *ngIf="currentLang === 'es'"></i>
        </button>
        <button class="sidebar-lang-option" [class.sidebar-lang-option--selected]="currentLang === 'en'" (click)="selectLang('en')">
          <span>🇺🇸</span> {{ texts.langEnglish }}
          <i class="fa fa-check ml-auto" *ngIf="currentLang === 'en'"></i>
        </button>
      </div>
    </div>
    <div class="btn-closeLogout d-flex align-items-end mb-3">
      <button type="button" class="btn btn-block btn-danger btn-lg shadow btn-circle" (click)="closeLogout()">
        <small>
          {{ texts.logoutButton }}
          <em class="fas fa-sign-in-alt ml-2"></em>
        </small>
      </button>
    </div>
  </div>
</nav>
